import { render, staticRenderFns } from "./TgpZone.vue?vue&type=template&id=71806bfb"
import script from "./TgpZone.vue?vue&type=script&lang=js"
export * from "./TgpZone.vue?vue&type=script&lang=js"
import style0 from "./TgpZone.vue?vue&type=style&index=0&id=71806bfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports